import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useHamburgerMenuStyles = (theme: Theme) => {
  return {
    root: css({
      '&.menu-wrapper.hamburger-menu': {
        padding: 0,
        margin: 0,
        marginLeft: theme.spacing(1),
        '& .MuiIconButton-root.header-menu-button': {
          fontSize: '2rem',
          lineHeight: '5rem',
          margin: 0,
          padding: 0,
          maxHeight: 40,
          '&:focus': { border: 'none' },
          '&:active': { border: 'none' },
        },
      },
    }),
    menuList: css({
      '&.hamburger-menu-list': {
        maxHeight: 600,
        padding: theme.spacing(0.5),
      },
      '& .header-menu-section': {
        marginTop: theme.spacing(0.5),
      },
    }),
    icon: css({
      padding: 0,
    }),
    mainAction: css({
      '&.main-action': {
        '& .MuiTypography-subtitle1': {
          color: theme.palette.grey['A700'],
        },
        '& .MuiListItemIcon-root': {
          color: theme.palette.grey['A700'],
          marginRight: theme.spacing(0.25),
          fontSize: '1.5rem',
          justifyContent: 'center',
        },
      },
    }),
    signOut: css({
      '&.MuiMenuItem-root.main-action': {
        paddingBottom: theme.spacing(1.5),
      },
    }),
    userName: css({
      whiteSpace: 'nowrap',

      '&.MuiTypography-subtitle1': {
        color: theme.palette.text.primary,
      },
    }),
  };
};
